import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../../../PageHeader';
import CorporateSectionLayout from '../../../CorporateSectionLayout';
import KomitePerusahaan from './KomitePerusahaan';

function KomitePerusahaanLayout() {
    const items = [{ id: 'komite-perusahaan', number: '01', label: 'Komite Perusahaan', content: <KomitePerusahaan /> }];
    return <>
        <Helmet><title>Komite Perusahaan | PT Len Telekomunikasi Indonesia</title><meta name="description" content="Komite Perusahaan PT Len Telekomunikasi Indonesia." /><link rel="canonical" href="https://www.len-telko.co.id/tata-kelola-perusahaan/komite-perusahaan" /></Helmet>
        <PageHeader title="Komite Perusahaan" />
        <CorporateSectionLayout title="Komite Perusahaan" eyebrow="Tata Kelola Perusahaan" items={items} />
    </>;
}
export default KomitePerusahaanLayout;
